<template>
<span :class="['mlink', applyState]">
    <span :class="['dot', applyState]"></span>{{applyStateName}}
</span>
</template>
<script>
// 申请1待申请2待授权3已授权4已拒绝
const StatusMap = {
    '0': {
        text: '待申请',
        type: 'warning'
    },
    '1': {
        text: '待申请',
        type: 'warning'
    },
    '2': {
        text: '待授权',
        type: 'warning'
    },
    '3': {
        text: '已授权',
        type: 'success'
    },
    '4': {
        text: '已拒绝',
        type: 'danger'
    }
}

// 01待受理
// 02已受理
// 03已退回
const TagMap = {
    '1': {
        text: '待受理',
        type: 'warning'
    },
    '2': {
        text: '已受理',
        type: 'success'
    },
    '3': {
        text: '已退回',
        type: 'danger'
    }
}

// PBDSQ(1, "待授权"),
//     PBYSX(2, "已失效"),
//     PBYTY(3, "同意"),
//     PBBTY(4, "不同意");
const ApplyStatusMap = {
    '1': {
        text: '待授权',
        type: 'warning'
    },
    '2': {
        text: '已失效',
        type: 'danger'
    },
    '3': {
        text: '同意',
        type: 'success'
    },
    '4': {
        text: '不同意',
        type: 'danger'
    }
}
const ApprovalStatusMap ={
    '1': {
        text: '待核准',
        type: 'warning'
    },
    '2': {
        text: '已拒绝',
        type: 'danger'
    },
    '3': {
        text: '已同意',
        type: 'success'
    }
}

export default {
    props: {
        status: {
            // 字符串或者数字
            type: [String, Number],
        },
        mapName: {
            type: String,
            default: 'status'
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
        applyStateName() {
            return this.dataMap[this.status]?.text || ''
        },
        applyState() {
            return this.dataMap[this.status]?.type || ''
        },
        dataMap() {
            switch (this.mapName) {
                case 'status':
                    return StatusMap
                case 'tag':
                    return TagMap
                case 'applyStatus':
                    return ApplyStatusMap
                case 'approvalStatus':
                    return ApprovalStatusMap 
                default:
                    return StatusMap
            }
        }
    }
}
</script>

<style lang="less" scoped>
.mlink {
    &.success {
        color: #52C41A;
    }
    &.danger {
        color: #F5222D;
    }
    &.warning {
        color: #FA8C16;
    }
}
.dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 2px;
    &.danger {
        background-color: #F5222D;
    }
    &.warning {
        background-color: #FA8C16;
    }
    &.success {
        background-color: #52C41A;
    }
}
</style>